import { createSlice } from "@reduxjs/toolkit";

const initialState = {
      oneTile: "",
      twoTile: "",
      threeTile: "",
      fourTile: "",
      fiveTile: "",
      sixTile: "",
      sevenTile: "",
      eightTile: "",
      nineTile: "",
      tenTile: "",
      elevenTile: "",
      twelveTile: "",
      thirteenTile: "",
      fourteenTile: "",
      fifteenTile: "",
      sixteenTile: "",
      seventeenTile: "",
      eighteenTile: "",
      nineteenTile: "",
      twentyTile: "",
      twentyOneTile: "",
      twentyTwoTile: "",
      twentyThreeTile: "",
      twentyFourTile: "",
      twentyFiveTile: "",
      twentySixTile: "",
      twentySevenTile: "",
      twentyEightTile: "",
      twentyNineTile: "",
      thirtyTile: "",
    };

const tileWordSlice = createSlice({
  name: "tileWordSlice",
  initialState,
  reducers: {
    updateOneTile: (state, action) => {
      state.oneTile = action.payload;
      return state;
    },
    updateTwoTile: (state, action) => {
      state.twoTile = action.payload;
      return state;
    },
    updateThreeTile: (state, action) => {
      state.threeTile = action.payload;
      return state;
    },
    updateFourTile: (state, action) => {
      state.fourTile = action.payload;
      return state;
    },
    updateFiveTile: (state, action) => {
      state.fiveTile = action.payload;
      return state;
    },
    updateSixTile: (state, action) => {
      state.sixTile = action.payload;
      return state;
    },
    updateSevenTile: (state, action) => {
      state.sevenTile = action.payload;
      return state;
    },
    updateEightTile: (state, action) => {
      state.eightTile = action.payload;
      return state;
    },
    updateNineTile: (state, action) => {
      state.nineTile = action.payload;
      return state;
    },
    updateTenTile: (state, action) => {
      state.tenTile = action.payload;
      return state;
    },
    updateElevenTile: (state, action) => {
      state.elevenTile = action.payload;
      return state;
    },
    updateTwelveTile: (state, action) => {
      state.twelveTile = action.payload;
      return state;
    },
    updateThirteenTile: (state, action) => {
      state.thirteenTile = action.payload;
      return state;
    },
    updateFourteenTile: (state, action) => {
      state.fourteenTile = action.payload;
      return state;
    },
    updateFifteenTile: (state, action) => {
      state.fifteenTile = action.payload;
      return state;
    },
    updateSixteenTile: (state, action) => {
      state.sixteenTile = action.payload;
      return state;
    },
    updateSeventeenTile: (state, action) => {
      state.seventeenTile = action.payload;
      return state;
    },
    updateEighteenTile: (state, action) => {
      state.eighteenTile = action.payload;
      return state;
    },
    updateNineteenTile: (state, action) => {
      state.nineteenTile = action.payload;
      return state;
    },
    updateTwentyTile: (state, action) => {
      state.twentyTile = action.payload;
      return state;
    },
    updateTwentyOneTile: (state, action) => {
      state.twentyOneTile = action.payload;
      return state;
    },
    updateTwentyTwoTile: (state, action) => {
      state.twentyTwoTile = action.payload;
      return state;
    },
    updateTwentyThreeTile: (state, action) => {
      state.twentyThreeTile = action.payload;
      return state;
    },
    updateTwentyFourTile: (state, action) => {
      state.twentyFourTile = action.payload;
      return state;
    },
    updateTwentyFiveTile: (state, action) => {
      state.twentyFiveTile = action.payload;
      return state;
    },
    updateTwentySixTile: (state, action) => {
      state.twentySixTile = action.payload;
      return state;
    },
    updateTwentySevenTile: (state, action) => {
      state.twentySevenTile = action.payload;
      return state;
    },
    updateTwentyEightTile: (state, action) => {
      state.twentyEightTile = action.payload;
      return state;
    },
    updateTwentyNineTile: (state, action) => {
      state.twentyNineTile = action.payload;
      return state;
    },
    updateThirtyTile: (state, action) => {
      state.thirtyTile = action.payload;
      return state;
    },
    resetTiles: (state, action) => {
      state.oneTile = "";
      state.twoTile = "";
      state.threeTile = "";
      state.fourTile = "";
      state.fiveTile = "";
      state.sixTile = "";
      state.sevenTile = "";
      state.eightTile = "";
      state.nineTile = "";
      state.tenTile = "";
      state.elevenTile = "";
      state.twelveTile = "";
      state.thirteenTile = "";
      state.fourteenTile = "";
      state.fifteenTile = "";
      state.sixteenTile = "";
      state.seventeenTile = "";
      state.eighteenTile = "";
      state.nineteenTile = "";
      state.twentyTile = "";
      state.twentyOneTile = "";
      state.twentyTwoTile = "";
      state.twentyThreeTile = "";
      state.twentyFourTile = "";
      state.twentyFiveTile = "";
      state.twentySixTile = "";
      state.twentySevenTile = "";
      state.twentyEightTile = "";
      state.twentyNineTile = "";
      state.thirtyTile = "";  
      return state;
    },
  },
});

export const {
  updateOneTile,
  updateTwoTile,
  updateThreeTile,
  updateFourTile,
  updateFiveTile,
  updateSixTile,
  updateSevenTile,
  updateEightTile,
  updateNineTile,
  updateTenTile,
  updateElevenTile,
  updateTwelveTile,
  updateThirteenTile,
  updateFourteenTile,
  updateFifteenTile,
  updateSixteenTile,
  updateSeventeenTile,
  updateEighteenTile,
  updateNineteenTile,
  updateTwentyTile,
  updateTwentyOneTile,
  updateTwentyTwoTile,
  updateTwentyThreeTile,
  updateTwentyFourTile,
  updateTwentyFiveTile,
  updateTwentySixTile,
  updateTwentySevenTile,
  updateTwentyEightTile,
  updateTwentyNineTile,
  updateThirtyTile,
  resetTiles,
} = tileWordSlice.actions;

export default tileWordSlice;
